/**
 * Enumeration to list all possible states for an external production
 */
export enum ExternalProductionState {
  NEW = 'new',
  WAITING = 'waiting',
  ACCEPTED = 'accepted',
  PROGRESS = 'progress',
  FINISHED = 'finished',
  CANCELLED = 'cancelled',
}
